module.exports = __webpack_public_path__ + "img/DE03950.62125e65.png";